import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/wallet/components/LoyaltyShop/PrizeDetail/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/stores/session/useSession.ts");
